export enum EMPHASIZER_MARK {
    bold = 'bold',
    italicize = 'italicize',
    strikethrough = 'strikethrough',
    underline = 'underline',
}
